import { Howl } from 'howler';

// Per-URL Howl cache. Samples are constructed lazily on first play and
// kept resident for the session — the browser reclaims on tab close.
// Howler handles its own AudioContext unlock via document-level gesture
// listeners installed on import; `src/effects/audio.ts` reads Howler.ctx
// so the synth path shares the same context.

const cache = new Map<string, Howl>();

export function playSample(url: string, opts?: { volume?: number }): void {
  if (globalThis.window === undefined) return;
  let howl = cache.get(url);
  if (!howl) {
    howl = new Howl({ src: [url], preload: true, html5: false });
    cache.set(url, howl);
  }
  if (opts?.volume !== undefined) howl.volume(opts.volume);
  howl.play();
}

export function __resetSampleCache(): void {
  cache.clear();
}
